import { render } from "./SchemaMarkupDate.vue?vue&type=template&id=41687a1e"
import script from "./SchemaMarkupDate.vue?vue&type=script&lang=js"
export * from "./SchemaMarkupDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__